export interface Semaphore {
  acquire(): Promise<void>;
  release(): void;
}

export const createSemaphore = (max: number): Semaphore => {
  let current = 0;
  const queue: (() => void)[] = [];

  return {
    async acquire() {
      if (current < max) {
        current++;

        return;
      }

      await new Promise<void>((resolve) => queue.push(resolve));
      current++;
    },

    release() {
      current--;
      const next = queue.shift();

      if (next) {
        next();
      };
    },
  };
};
